import React, { useState, useRef } from 'react';
import {
  Avatar,
  Box,
  ButtonBase,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Typography,
  SvgIcon,
  Divider
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useAuth0 } from '@auth0/auth0-react';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { BookOpen as BookOpenIcon } from 'react-feather';
import { useIntl, FormattedMessage } from 'react-intl';

import useUser from 'src/hooks/useUser';
import { basename } from 'src/config';
import Tooltip from 'src/components/Tooltip';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  }
}));

const Account = () => {
  const classes = useStyles();
  const { user } = useUser();
  const { logout } = useAuth0();
  const { formatMessage } = useIntl();
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () =>
    logout({ returnTo: `${window.location.origin}${basename}` });

  return (
    <>
      <Tooltip
        title={formatMessage({
          defaultMessage: 'プロフィール',
          id: 'TopBar.Account.Tooltip.Title'
        })}
      >
        <Box component={ButtonBase} onClick={handleOpen} ref={ref}>
          <Avatar alt="User" className={classes.avatar} src={user.picture} />
        </Box>
      </Tooltip>
      <Menu
        onClose={handleClose}
        anchorOrigin={{ vertical: 40, horizontal: 'center' }}
        keepMounted // なぜこれが必要かは不明だがMaterial-UIのexampleでは使用している
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem>
          <ListItemIcon>
            <Avatar alt="User" className={classes.avatar} src={user.picture} />
          </ListItemIcon>
          <div>
            <Typography variant="subtitle2" noWrap>
              {user.name}
            </Typography>
            <Typography variant="subtitle2" noWrap>
              {user.email}
            </Typography>
          </div>
        </MenuItem>
        <MenuItem
          dense
          component="a"
          href="https://app.portal.bbtower.com/bois/profile/edit"
          target="_blank"
        >
          <ListItemIcon>
            <ManageAccountsIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1">
                <FormattedMessage
                  defaultMessage="個人設定"
                  id="TopBar.Account.Typography.Setting"
                />
              </Typography>
            }
          />
        </MenuItem>
        <MenuItem
          dense
          component="a"
          href={
            user.language === 'ja'
              ? 'https://www.bois.bbtower.co.jp/docs/customer/service/data_center/admissions/otemachi_shin_otemachi/'
              : 'https://www.bois.bbtower.co.jp/docs/customer/en/service/data_center/admissions/otemachi_shin_otemachi/'
          }
          target="_blank"
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <BookOpenIcon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1">
                <FormattedMessage
                  defaultMessage="ご利用ガイド"
                  id="TopBar.Account.Typography.Doc"
                />
              </Typography>
            }
          />
        </MenuItem>
        <Divider />
        <MenuItem dense onClick={handleLogout}>
          <FormattedMessage
            defaultMessage="ログアウト"
            id="TopBar.Account.Typography.Logout"
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default Account;
